<template>
  <div class="relative">
    <div class="d-flex justify-end align-center action-header pa-2" v-if="selected.length">
      <v-btn outlined color="success" @click="() => onAttendAll()" class="mr-2">tất cả có mặt</v-btn>
      <v-btn outlined color="warning" @click="() => onAttendAll(true)">tất cả vắng mặt</v-btn>
    </div>
    <v-data-table :items="students" :headers="headers" disable-sort show-select v-model="selected">
      <template v-slot:item="{ item, expand, isExpanded, select, isSelected }">
        <TableRow :item="item" :expand="expand" :isExpanded="isExpanded" :select="select" :isSelected="isSelected" />
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { Student } from '@/plugins/api'
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import { headers } from './headers'
import { mapState } from 'vuex'
import { get } from 'lodash'
import TableRow from './TableRow.vue'
export default {
  components: { CardStudentName, TableRow },
  data() {
    return { students: [], headers, selected: [], status: null }
  },
  async mounted() {
    await this.init()
  },
  computed: { ...mapState('ClassNoteDetail', ['slot']) },
  methods: {
    async init() {
      this.students = await Student.fetch({ currentClass: get(this.slot, 'class.id'), _sort: 'nameToNumber:ASC' })
    },
    onAttendAll() {
      this.$dialog.confirm({
        title: 'Xác nhận tất cả có mặt',
        text: 'Bạn có chắc chắn muốn xác nhận tất cả học sinh đã chọn đều có mặt trong tiết dạy này?',
        okText: 'Có',
        cancelText: 'Hủy',
        done: () => {},
      })
    },
  },
  filters: {
    getStatus() {
      return 'Chưa điểm danh'
    },
  },
}
</script>
